import React, { ReactElement } from 'react';
import { Row, Alert } from '@dexma/ui-components';
import { StyledEditDashboardsPage } from 'adapter/in/dashboards/pages/EditDashboard/style';
import EditDashboardNameModalContainer from 'adapter/in/dashboards/containers/Modals/EditNameModal';
import EditDashboardPageConfirmChangesModalContainer from 'adapter/in/dashboards/containers/Modals/DiscardChangesModal';
import EditDashboardPageEditHeaderContainer from 'adapter/in/dashboards/containers/EditDashboard/Header';
import WidgetMenuContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu';
import EditLayoutContainer from 'adapter/in/dashboards/containers/EditDashboard/EditLayout';
import { AlertMessageType } from 'adapter/in/common/context/Alert';
import { StyledAnimationDiv } from 'adapter/in/common/style';

export const EditDashboardPage = (props: {
    id: string;
    showSidePanelMenu: boolean;
    alertMessage: AlertMessageType;
    alertType?: 'info' | 'outline' | 'basic' | 'warning' | 'success' | 'error';
    animationStyle: React.CSSProperties;
    showAlert: boolean;
}): ReactElement => {
    const { id, showSidePanelMenu, alertMessage, alertType, animationStyle, showAlert } = props;

    return (
        <StyledEditDashboardsPage fluid data-testid='edit-dashboard' $showAlert={showAlert}>
            <StyledAnimationDiv $animationStyle={animationStyle}>
                <Alert
                    description={alertMessage?.toString()}
                    type={alertType as 'info' | 'outline' | 'basic' | 'warning' | 'success' | 'error'}
                    showIcon
                />
                <EditDashboardPageEditHeaderContainer />
                <EditDashboardNameModalContainer />
                <EditDashboardPageConfirmChangesModalContainer />
                <Row
                    data-testid='layout-row'
                    className='layout'
                    style={{
                        paddingRight: showSidePanelMenu ? 'max(25%, 400px)' : '0px',
                        transition: 'all 0.2s linear 0s',
                    }}
                >
                    <EditLayoutContainer id={id} />
                    <WidgetMenuContainer />
                </Row>
            </StyledAnimationDiv>
        </StyledEditDashboardsPage>
    );
};

export default EditDashboardPage;
